// src/components/dashboard/AdminDocuments.js
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Users, Settings } from 'lucide-react';
import DocumentsManager from './shared/DocumentsManager';

const AdminDocuments = () => {
  const { dossierId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Admin */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/admin')}
                className="flex items-center text-gray-600 hover:text-gray-900"
              >
                <ArrowLeft className="w-5 h-5 mr-2" />
                Retour au dashboard admin
              </button>
              <div className="h-6 w-px bg-gray-300"></div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 flex items-center">
                  <Shield className="w-6 h-6 mr-2 text-blue-600" />
                  Gestion des documents - Dossier {dossierId}
                </h1>
                <p className="text-gray-600">Interface administrateur avec fonctionnalités avancées</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800">
                <Users className="w-4 h-4 mr-1" />
                Admin
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Bannière d'informations admin */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <Settings className="w-5 h-5 text-blue-500 mt-0.5 mr-3" />
            <div>
              <h3 className="text-sm font-medium text-blue-900">Mode Administrateur</h3>
              <p className="text-sm text-blue-700 mt-1">
                Vous avez accès aux fonctionnalités avancées : documents internes, workflow de validation, 
                actions en lot, analytics détaillées et gestion des permissions.
              </p>
            </div>
          </div>
        </div>

        {/* Gestionnaire de documents avec privilèges admin */}
        <DocumentsManager 
          dossierId={dossierId}
          isAdmin={true}
          canEdit={true}
          showInternalDocs={true}
        />
      </div>
    </div>
  );
};

export default AdminDocuments;